module.exports = __webpack_public_path__ + "img/21.8d4aab32.jpeg";